import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { CLEARING_DOC_API } from "./apiRoutes";

const mutateAddClearingDoc = async ({
  communityId,
  data,
}: {
  communityId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.post(`${CLEARING_DOC_API(communityId)}/`, data);
};

const useAddClearingDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddClearingDoc,
    ...queryParams,
  });

export default useAddClearingDocMutation;
